import { useContext, useMemo } from 'react'
import { LabRemoteConfigKeys } from 'constants/lab'
import GeoContext from 'contexts/geoContext'
import { useLabRemoteConfig } from 'hooks/FeatureFlag/useLabRemoteConfig'
import { useAppSelector } from 'hooks/reduxHooks'
import { resolveLoyaltyWhatsNewRemoteConfig } from 'loyalty/lib/loyaltyWhatsNew/resolveLoyaltyWhatsNewRemoteConfig'

/**
 * Resolves the svc-lab–configured "What's new" cards for the current region.
 * Content, region targeting, scheduling and optional per-card Optimizely gating
 * are all driven by the `loyalty:societeAccountWhatsNew` remote config.
 */
function useLoyaltyWhatsNewCards() {
  const { currentRegionCode } = useContext(GeoContext)
  const payload = useLabRemoteConfig(LabRemoteConfigKeys.loyaltyAccountWhatsNew)
  const optimizelyFeatureFlags = useAppSelector(state => state.optimizely.optimizelyFeatureFlags)

  return useMemo(
    () => resolveLoyaltyWhatsNewRemoteConfig(
      payload,
      currentRegionCode,
      flagKey => !!optimizelyFeatureFlags[flagKey],
    ),
    [payload, currentRegionCode, optimizelyFeatureFlags],
  )
}

export default useLoyaltyWhatsNewCards
